import { BehaviorSubject, combineLatest as observableCombineLatest, Observable } from 'rxjs';
import { combineLatest, filter, map, take, takeUntil } from 'rxjs/operators';
import { Injectable } from '@angular/core'
import { NavigationStart, Router } from '@angular/router'

import { select, Store } from '@ngrx/store'

import * as fromBase from '../../base/reducers'
import * as fromAuth from '../../auth/reducers'

import { UXPage } from '../../core/models/ux-page'
import { TranslateService } from '@ngx-translate/core'
import { Crumb } from '../models/crumb'
import { Title } from '@angular/platform-browser';
import { TenantService } from '../../shared/services/tenant.service';

@Injectable()
export class PageRoutingService {
  private pageSubject = new BehaviorSubject<UXPage>(null)
  private pageTrailSubject = new BehaviorSubject<Crumb[]>([])
  private breadcrumbsSubject = new BehaviorSubject<boolean>(true)
  private simplifiedHeaderSubject = new BehaviorSubject<boolean>(false)

  constructor(
    private translate: TranslateService,
    private router: Router,
    private titleSvc: Title,
    private tenantSvc: TenantService,
    private store: Store<fromBase.State>
  ) {

    observableCombineLatest(
      store.pipe(
        select(fromBase.getCurrentPage),
      ),
      store.pipe(
        select(fromBase.getAppName)
      )
    ).pipe(
      map(([page, appName]) => {
        if (appName) {
          page && page.name
            ? this.titleSvc.setTitle(`${page.name} - ${appName} - Webshop`)
            : this.titleSvc.setTitle(`${appName} - Webshop`)
        } else {
          this.titleSvc.setTitle('Webshop')
        }
        return page
      }))
      .subscribe(this.pageSubject)
    store.pipe(
      select(fromBase.getPageTrail),
      map(trail => trail.map(page => (<Crumb>{
        name: page && page.name,
        slug: page && page.slug
      }))))
      .subscribe(this.pageTrailSubject)
  }

  public get page$(): Observable<UXPage> {
    return this.pageSubject.asObservable()
  }

  public pageUntil$(predicate: (url: string) => boolean): Observable<UXPage> {
    return this.pageSubject.asObservable().pipe(
      takeUntil(
        this.router.events.pipe(
          filter(ev => ev instanceof NavigationStart),
          map((ev: NavigationStart) => ev.url),
          filter(predicate),
          take(1)
        )
      ))
  }

  public get breadCrumbs$(): Observable<Crumb[]> {
    return this.pageTrailSubject.asObservable().pipe(
      combineLatest(
        this.translate.stream(['header.home'])
      ),
      map(result => {
        if (result[0].find(item => item.slug === 'home'))
          return result[0]
        else
          return <Crumb[]>[
            {name: result[1]['header.home'], slug: '/home'},
            ...result[0]
          ]
      }),)
  }

  public get breadcrumbsStatus$(): Observable<boolean> {
    return this.breadcrumbsSubject.asObservable()
  }

  public set breadcrumbsStatus(value: boolean) {
    this.breadcrumbsSubject.next(value)
  }

  public get simplifiedHeaderStatus$(): Observable<boolean> {
    return this.simplifiedHeaderSubject.asObservable()
  }

  public set simplifiedHeaderStatus(value: boolean) {
    this.simplifiedHeaderSubject.next(value)
  }

  public get tenantWantsBreadcrumbs$(): Observable<boolean> {

    // SK TODO: make this a tenant setting together with bakkie
    let wantsCrumbs = new BehaviorSubject(true);
    this.tenantSvc.tenantName$.subscribe(tenantName => {
     if (tenantName && tenantName.toLowerCase() === "bolsius") {
        wantsCrumbs = new BehaviorSubject(false);
      }
    })
    return wantsCrumbs.asObservable();
  }

}
